<!--
 * @Autor: Aberg
 * @Date: 2020-10-21 10:03:19
 * @LastEditTime: 2022-09-28 13:44:12
 * @Description: 
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="home" v-cloak v-loading="loading">
    
    <img class="top-banner" v-if="red && red.id" :src="red.banner" alt="" @click="goNewsDetail(red.article_id, red.type, red.link_url)">
    
    <p class="header common-container">
      <img class="logo" :src="require('@/assets/image/16logo.png')" alt="">
      <!-- <img class="logo-text" :src="require('@/assets/image/logo_jsp_text.png')" alt=""> -->
    </p>
    <div class="nav">
      <div class="nav-content">
        <ul class="left">
          <li v-for="(item, index) in nav" :key="index">
            <span @click="goNav(item.id, item.title, item.type)">{{ item.title }}</span></li>
        </ul>
        <!-- <div class="right" @click="goPage('platform')">
          <img :src="require('@/assets/image/icon_applications.png')" alt="">
          <p>媒体矩阵</p>
        </div> -->
      </div>
    </div>
    <!-- topic -->
    <div class="topic" v-if="info.topic && info.topic.length > 0">
      <img v-for="(item, index) in info.topic" :key="index" @click="goTopic(item.id)" :src="item.cover" alt="">
    </div>
    <!-- 主要新闻 -->
    <div class="swiper-news" v-if="info.news && info.news.child.length > 0">
      <div class="swiper-box">
        <swiper class="swiper" ref="swiper" :options="swiperOption">
          <swiper-slide v-for="(item, index) in info.news.child" :key="index">
            <img class="item" :src="item.cover" alt="" @click="goNewsDetail(item.id, 1, item.jump_url)">
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
      <div class="news-container">
        <p v-for="(item, index) in info.news.child" :key="index" :class="{'active': activeIndex == index}" @mouseover="slideTo(index)"
        @click="goNewsDetail(item.id, 1, item.jump_url)">
          {{ item.title }}
        </p>
      </div>
    </div>
    <div class="container common-container" style="padding-bottom: 0.15rem;">
      <!-- 热点推荐 -->
      <!-- <p class="home-title">
        <span class="name">新闻</span>
        <span class="more" @click="goList(info.news.id, '新闻')">更多</span>
      </p>
      <div class="m1">
        <div class="left" style="position: relative;cursor: pointer;" @click="goVideoDetail(info.news.id, '新闻', info.news_big.id)">
          <img :src="info.news_big.cover" alt="">
          <img :src="require('@/assets/image/pic_mask.png')" class="hot-mask" alt="">
          <p class="hot-title">{{ info.news_big.title }}</p>
        </div>
        <ul class="right">
          <li v-for="(item, index) in info.news.child" :key="index" :class="{'three': true, 'mb1': index < 3}" @click="goVideoDetail(info.news.id, '新闻', item.id)">
            <img :src="item.cover" alt="">
            <p class="text">{{ item.title }}</p>
          </li>
        </ul>
      </div> -->
      <!-- 白皮书 -->
      <!-- <p class="home-title">
        <span class="name">财经</span>
        <span class="more" @click="goPage('news/list/' + info.economy.id)">更多</span>
      </p>
      <ul class="news">
        <li v-for="(item, index) in info.economy.child" :key="index" @click="goPage('news/detail/' + item.id)">
          <span>{{ item.title }}</span>
        </li>
      </ul> -->
      <!-- 财经 -->
      <p class="home-title" v-if="info.economy">
        <span class="name">财经</span>
        <span class="more" @click="goList(info.economy.id, '财经')">更多</span>
      </p>
      <ul class="m3" v-if="info.economy">
        <li v-for="(item, index) in info.economy.child" :key="index" @click="goVideoDetail(info.economy.id, info.economy.title, item.id)">
          <img :src="item.cover" alt="">
          <p class="text">{{ item.title }}</p>
        </li>
      </ul>
      <!-- 党教 -->
      <p class="home-title" v-if="info.party">
        <span class="name">党教</span>
        <span class="more" @click="goList(info.party.id, '党教')">更多</span>
      </p>
      <ul class="m2" v-if="info.party" style="flex-wrap: nowrap">
        <li v-for="(item, index) in info.party.child" :key="index" :class="{'mb': index < 6}" @click="goVideoDetail(info.party.id, info.party.title, item.id)">
          <img :src="item.cover" alt="">
          <p class="text">{{ item.title }}</p>
        </li>
      </ul>
      <!-- 科普 -->
      <p class="home-title" v-if="info.science">
        <span class="name">科普</span>
        <span class="more" @click="goList(info.science.id, '科普')">更多</span>
      </p>
      <ul class="m3" v-if="info.science">
        <li v-for="(item, index) in info.science.child" :key="index" @click="goVideoDetail(info.science.id, info.science.title, item.id)">
          <img :src="item.cover" alt="">
          <p class="text">{{ item.title }}</p>
        </li>
      </ul>
      <!-- 旅游 -->
      <p class="home-title" v-if="info.tour">
        <span class="name">旅游</span>
        <span class="more" @click="goList(info.tour.id, '旅游')">更多</span>
      </p>
      <div class="m1" v-if="info.tour">
        <div class="left short" @click="goVideoDetail(info.tour.id, info.tour.title, info.tour_big.id)">
          <img :src="info.tour_big.cover" alt="">
          <p class="text">{{ info.tour_big.title }}</p>
        </div>
        <ul class="right">
          <li v-for="(item, index) in info.tour.child" :key="index" class="four" :class="{'mb': index < 4}" @click="goVideoDetail(info.tour.id, info.tour.title, item.id)">
            <img :src="item.cover" alt="">
            <p class="text">{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <!-- 纪实 -->
      <p class="home-title" v-if="info.real">
        <span class="name">纪实</span>
        <span class="more" @click="goList(info.real.id, '纪实')">更多</span>
      </p>
      <ul class="m2" v-if="info.real" style="flex-wrap: nowrap">
        <li v-for="(item, index) in info.real.child" :key="index" @click="goVideoDetail(info.real.id, info.real.title, item.id)">
          <img :src="item.cover" alt="">
          <p class="text">{{ item.title }}</p>
        </li>
      </ul>
    </div>
    <!-- 友情链接 end -->
    <Footer />
  </div>
</template>
<script>
import { getNav, getHomeList, redOpt } from "@/service/api/home";
import { mapState } from "vuex";
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
var vm = null
export default {
  name: 'home',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      nav: [],
      info: {
        // news_big: {},
        // news: {},
        economy: {},
        party: {},
        science: {},
        tour_big: {},
        tour: {},
        real: {}
      },
      activeIndex: 0,
      swiperOption: {
        // autoplay: {
        //   disableOnInteraction: false
        // },
        loop: true,
        
          // navigation: {
          //   prevEl: '.swiper-button-prev',
          //   nextEl: '.swiper-button-next'
          // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on:{
          slideChange: function(){
            vm.activeIndex = this.realIndex
          }
        },
      },
      red: {}
    }
  },
  mounted() {
    vm = this
  },
  computed: {
    ...mapState(["navList"]),
  },
  created() {
    this.getNavList()
    this.getList()
    this.getRed()
  },
  methods: {
    slideTo(index) {
      this.$refs.swiper.swiper.slideToLoop(index, 0, false);//切换到第一个slide，速度为1秒
    },
    getRed() {
      redOpt().then(res => {
        this.red = res.data
      })
    },
    getNavList() {
      // console.log(this.navList)
      if (this.navList && this.navList.length > 0) {
        this.nav = this.navList
        return
      }
      getNav().then(res => {
        this.nav = res.data
        this.$store.commit("changeNavsList", res.data)
      })
    },
    getList() {
      getHomeList().then(res => {
        this.loading = false
        this.info = res.data
        // this.info.news_big       = res.data.news.child[0]
        // this.info.news.child     = res.data.news.child.slice(1, res.data.news.child.length)
        if (this.info.tour) this.info.tour_big    = res.data.tour.child[0]
        if (this.info.tour) this.info.tour.child  = res.data.tour.child.slice(1, res.data.tour.child.length)
        // this.$store.commit("changeNavsList", res.data)


        if (this.info.economy) this.info.economy.child= res.data.economy.child.slice(0, 5)
        if (this.info.party) this.info.party.child= res.data.party.child.slice(0, 4)
        if (this.info.science) this.info.science.child= res.data.science.child.slice(0, 5)
        if (this.info.real) this.info.real.child= res.data.real.child.slice(0, 4)
      })
    },
    goNav(cid, cname, type) {
      if (type == 1) {
        this.$router.push(`/news/list/${cid}/${cname}`)
        return
      }
      this.$router.push(`/video/list/${cid}/${cname}`)
    },
    goPage(page) {
      this.$router.push('/' + page)
    },
    goList(cid, cname) {
      this.$router.push(`/video/list/${cid}/${cname}`)
    },
    goVideoDetail(cid, cname, vid) {
      this.$router.push(`/video/detail/${cid}/${cname}/${vid}`)
    },
    goTopic(id) {
      this.$router.push(`/topic/${id}`)
    },
    goTopicDetail(id) {
      this.$router.push(`/news/detail/${id}/专题`)
    },
    goNewsDetail(id, type = 1, link_url = '') {
      if (type == 2) {
        window.open(link_url)
        return
      }
      if (link_url) {
        window.open(link_url)
        return
      }
      this.$router.push(`/news/detail/${id}/新闻`)
    }
  }
}
</script>
<style lang="scss" scoped>
.top-banner {
  width: 100%;
  min-width: 14rem;
  max-height: 6.8rem;
  object-fit: cover;
  cursor: pointer;
}
.home {
  // height: 500px;
  // border: 1px solid #e3e3e3;
}
.topic {
  width: 14rem;
  margin: 0.3rem auto 0;
  font-size: 0;
  img {
    width: 100%;
    height: 1.4rem;
    object-fit: cover;
    margin-bottom: 0.3rem;
    cursor: pointer;
    border-radius: 0.1rem;
  }
}
.header {
  padding: 0.37rem 0 0.17rem;
  display: flex;
  align-items: center;
  .logo {
    width: 1.6rem;
    margin-right: 0.4rem;
  }
  .logo-text {
    width: 3.04rem;
  }
}
.nav {
  height: 0.55rem;
  background: #f4f4f4;
  &-content {
    width: 14rem;
    margin: 0 auto;
    // padding: 0.23rem 0;
    line-height: 0.55rem;
    display: flex;
    .left {
      width: 100%;
      // padding: 0 0.18rem;
      // padding-right: 1rem;
      // border-right: 0.02rem solid #333;
      // opacity: 0.3;
      display: flex;
      justify-content: space-between;
      // flex-wrap: wrap;
      position: relative;
      // &::after {
      //   content: '';
      //   position: absolute;
      //   right: 0;
      //   top: 0rem;
      //   width: 0.02rem;
      //   height: 0.54rem;
      //   background: rgba(51, 51, 51, 0.3);
      // }
      li {
        // width: 1.2rem;
        // margin-bottom: 0.1rem;
        font-size: 0.2rem;
        // line-height: 0.38rem;
        color: #333;
        span {
          cursor: pointer;
          &:hover {
            color: #B9000B;
            font-weight: bold;
          }
        }
      }
    }
    .right {
      margin-left: 0.83rem;
      cursor: pointer;
      img {
        width: 0.66rem;
      }
      p {
        font-size: 0.16rem;
        font-weight: bold;
        color: #333333;
        margin-top: -0.18rem;
      }

    }
  }
}
.container {
}
.news {
  display: flex;
  flex-wrap: wrap;
  li {
    width: calc(50% - 0.3rem);
    height: 0.77rem;
    font-size: 0.2rem;
    color: #333;
    position: relative;
    padding-left: 0.2rem;
    &:nth-child(odd) {
      margin-right: 0.6rem;
      // width: calc(50% - 0.6rem);
    }
    &::before {
      content: '';
      position: absolute;
      top: 0.07rem;
      left: 0;
      width: 0.13rem;
      height: 0.13rem;
      background: #2270D0;
    }
    span {
      cursor: pointer;
      word-break: break-all;
      line-height: 0.32rem;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.mb {
  margin-bottom: 0.15rem;
}
.wrap-bottom {
  padding-bottom: 0.39rem;
}
.mb1 {
  height: 1.85rem;
}
.hot-mask {
  width: 100%;
  height: 1rem !important;
  position: absolute;
  bottom: 0.04rem;
  left: 0;
}
.hot-title {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  bottom: 0.2rem;
  z-index: 2;
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #fff;
    font-weight: bold;
  padding: 0.1rem 0.1rem 0;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.swiper-news {
  width: 14rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.swiper-box {
  width: 7.9rem;
  height: 4.45rem;
  position: relative;
  z-index: 2;
  .swiper {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0.1rem;
    }
  }
  
      
  .swiper-pagination {
    left: calc(50% - 0.5rem);
    bottom: 0.17rem;
    font-size: 0;
    :deep(.swiper-pagination-bullet) {
      margin: 0 0.05rem;
      width: 0.1rem;
      height: 0.1rem;
      background: #fff;
      opacity: 1;
      // border-radius: 0;
      cursor: pointer;
      // &:hover,
      &.active {
        
        background: #D1000F;
      }
      &.swiper-pagination-bullet-active {
        
        background: #D1000F;
      }
    }
  }
}
.news-container {
  box-sizing: border-box;
  width: 5.7rem;
  height: 4.45rem;
  background: #FFFFFF;
  box-shadow: 0px 0.02rem 0.12rem 0px #DFDDDD;
  border-radius: 0.1rem;
  padding: 0.07rem 0.16rem;
  p {
    box-sizing: border-box;
    width: 5.38rem;
    height: 0.86rem;
    line-height: 0.85rem;
    // margin-left: 0.52rem;
    // margin-bottom: 0.15rem;
    font-size: 0.2rem;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    position: relative;
    padding-left: 0.25rem;
    border-bottom: 0.01rem solid #E3E3E3;
    &:last-child {
      border-bottom: none;
    }
    &:hover, &.active {
      font-weight: bold;
    }
    &::before {
      content: '';
      box-sizing: border-box;
      position: absolute;
      top: 0.38rem;
      left: 0;
      width: 0.1rem;
      height: 0.1rem;
      border: 0.03rem solid #D1000F;
      border-radius: 50%;

    }
  }
}
</style>